import { MySquid, ProfileCompleteness, onConfigChange, onProfileCompletenessChange } from '@hub/shared'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { SubscriptionLike } from 'rxjs'
import CardMidiaKitHomeComponent from '../card-midiakit-home/card-midiakit-home.component'
import './box-reach-home.component.scoped.scss'
import { SqButton } from '@squidit/react-css'

interface BoxReachComponentProps {
  onVisibilityChange: (isVisible: boolean) => void
}

const BoxReachComponent = ({ onVisibilityChange }: BoxReachComponentProps) => {
  const { t } = useTranslation('boxReachComponent')
  const [profileCompleted, setProfileCompleted] = useState<ProfileCompleteness | null>(null)
  const onProfileChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const onConfigChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [configs, setConfig] = useState<MySquid | any>(null)

  const hasMediakitCompleted = useMemo(
    () =>
      profileCompleted?.mediakitCount?.detail?.length &&
      profileCompleted?.mediakitCount?.detail?.every((element) => element.percentage === 100),
    [profileCompleted]
  )

  useEffect(() => {
    onProfileChangeSubscription.current = onProfileCompletenessChange.subscribe((profileCompleteness) => {
      if (profileCompleteness) {
        setProfileCompleted(profileCompleteness)
      }
    })

    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid | any) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
    })

    return () => {
      onProfileChangeSubscription?.current?.unsubscribe()
      onConfigChangeSubscription?.current?.unsubscribe()
    }
  }, [])

  const isVisible = useMemo(
    () => !(configs?._id || (profileCompleted?.progressive?.percentage === 100 && profileCompleted?.mediakitCount?.percentage === 100)),
    [configs, profileCompleted]
  )

  useEffect(() => {
    onVisibilityChange(isVisible)
  }, [isVisible, onVisibilityChange])

  if (!isVisible) {
    return null
  }

  return (
    <div className={'section-box display-flex align-items-center p-3 box-reach'} style={{ backgroundColor: 'var(--background)' }}>
      <div className="text-left" style={{ minWidth: '120px' }}>
        <i className="fa-solid fa-rocket" style={{ fontSize: '2.3rem', marginBottom: '1rem' }}></i>
        <p dangerouslySetInnerHTML={{ __html: t('title') }} style={{ fontSize: '1.25rem' }}></p>
      </div>
      <CardMidiaKitHomeComponent
        icon={'fa-regular fa-photo-film'}
        text={t('makeMediakit')}
        button={
          profileCompleted?.mediakitCount?.detail?.length ? (
            hasMediakitCompleted ? (
              <span>
                {t('created')} <i className="fa-solid fa-circle-check green"></i>
              </span>
            ) : (
              <Link to="/mediakit">
                <SqButton size="sm">{t('access')}</SqButton>
              </Link>
            )
          ) : (
            <Link to="/mediakit">
              <SqButton size="sm">{t('create')}</SqButton>
            </Link>
          )
        }
      ></CardMidiaKitHomeComponent>
      <CardMidiaKitHomeComponent
        icon={'fa-regular fa-poll-people'}
        text={t('profileSurveys')}
        button={
          profileCompleted?.progressive?.percentage === 100 ? (
            <span>
              {t('answered')} <i className="fa-solid fa-circle-check green"></i>
            </span>
          ) : (
            <Link to="/profile/research">
              <SqButton size="sm">{t('toRespond')}</SqButton>
            </Link>
          )
        }
      ></CardMidiaKitHomeComponent>
    </div>
  )
}

export default BoxReachComponent
